const Project = ({
  Name,
  Description,
  Image,
  Platforms,
  Technologies,
  Link,
}) => (
  <a
    href={Link}
    target="_blank"
    rel="noreferrer"
    className="flex-none max-h-96 w-full mb-10 mx-auto z-9 before:absolute before:top-1 before:left-1 before:w-full before:h-full before:bg-teal relative hover:before:top-0 hover:before:left-0 before:duration-200 cursor-pointer"
  >
    <div className="relative z-10 inset-0 w-full h-full object-cover bg-white py-5 px-7">
      <div className="flex flex-row h-full">
        <div className="w-20 pr-3">
          {Image == null ? (
            <span className="font-bold text-6xl">{Name[0]}</span>
          ) : (
            <img className="m-auto" src={Image} alt={Name} />
          )}
        </div>
        <div className="flex flex-col flex-1 pl-5">
          <h1 className="text-black relative font-bold text-left text-lg">
            {Name}
          </h1>
          <p className="text-black relative text-left text-sm">{Description}</p>
          <span className="text-left pt-3 text-sm">
            <span className="font-bold pr-5">Technologies</span>
            <span>{Technologies}</span>
          </span>
          <span className="text-left text-sm">
            <span className="font-bold pr-5">Platforms</span>
            <span>{Platforms}</span>
          </span>
        </div>
      </div>
    </div>
  </a>
);

export default Project;
